var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('details',[_c('summary',{staticClass:"margin-left-l"},[_vm._v(_vm._s(_vm.type))]),_vm._v(" "),_c('meal-cards-group',{attrs:{"meals":_vm.meals}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ca12f8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/brand/health/components/nutritionPlan/MealTypeDetails.vue
// module id = null
// module chunks = 